import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';

export const commonLoadingStyles = css`

  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-top-color: #000;
  }

  &::before {
    content: '';
    position: fixed;
    top: 50%;
    right: calc(50% - 150px);
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50px;
    border: 2px solid #fff;
    border-top-color: #000;
    animation: loading .8s linear infinite;
    z-index: 1;

    @media (${breakpoint.mdMax}) {
      right: 45%;
    }
  }

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (${breakpoint.mdMin}) {
    margin-top: 26px;
  }
`;

export const overlayLoad = css`
  &::after {
      background: rgba(255, 255, 255, 0.75); 
    }
    ${commonLoadingStyles}

    &.guest {
      &::before {
        right: 50%;
      }
    }
`;

export const isLoading = css`
  &::after {
      background: rgba(255, 255, 255, 1); 
    }

    ${commonLoadingStyles}
`;

export const MyAccountTitle = styled.div`
  padding: 48px 8px 0px;

  @media (${breakpoint.mdMin}) {
    padding: 48px 0px 0px;
  }

  div {
    margin-top: 24px;
  }
`;

export const Wrapper = styled.div`
  @media (${breakpoint.mdMin}) {
    margin-top: 94px;
  }
`;
